module.exports = __webpack_public_path__ + "static/screens-plan-4ab12b91e010030f22de04a3bf86d35d.jpg";